import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderPaymentTypeEntity } from '../../domain/entities/OrderPaymentTypeEntity'
export class OrderPaymentTypeModel extends OrderPaymentTypeEntity {
  constructor(dataDto: OrderPaymentTypeModel) {
    super()
    mapEntityProperties<OrderPaymentTypeEntity>(this, dataDto)
  }
}
